import { render } from "./The404Page.vue?vue&type=template&id=2c68bf7f"
import script from "./The404Page.vue?vue&type=script&lang=js"
export * from "./The404Page.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/remote/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__